/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Intishigheraspect10Inputs */



/**

* @param {_Filter_Class_Intishigheraspect10Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_intishigheraspect10 = /** @type {((inputs?: _Filter_Class_Intishigheraspect10Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Intishigheraspect10Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("ist größer-gleich")
});
export { _filter_class_intishigheraspect10 as "_filter_class_IntISHIGHERAspect" }